module.exports = __webpack_public_path__ + "static/media/ac_logo_512.4028d71f.png";